jQuery(document).ready(function(){
    // const observer = new IntersectionObserver(entries => {
    //     console.log(entries);
    //     entries.forEach(entry => {
    //         console.log(entry);
    //         // const square = entry.target.querySelector('.square');
    //         if (entry.isIntersecting){
    //             entry.target.classList.add('square-animation');
    //             // square.classList.add('square-animation');
    //             return;
    //         }
    //         // square.classList.remove('square-animation');
    //     });
    // });
    
    // // Сообщить наблюдателю, какие элементы следует отслеживать
    // observer.observe(document.querySelector('.scrollAnimationWrapperBlock'));
    // observer.observe(document.querySelector('.scrollAnimationItemBlock'));


    function onEntry(entry) {
        entry.forEach(change => {
            if (change.isIntersecting) { change.target.classList.add('square-animation'); }
        });
    }
    let options = { threshold: [0.2] };
    let observer = new IntersectionObserver(onEntry, options);
    let elements = document.querySelectorAll('.scrollAnimationWrapperBlock, .scrollAnimationItemBlock, .btn');
    for (let elm of elements) {
        observer.observe(elm);
    }
});